export const fesha_url="https://www.fresha.com/a/taupo-luxury-nails-taupo-29-tongariro-street-aa3v89dx/booking?menu=true"

export const fb_url="https://www.facebook.com/taupoluxurynails"

export const ins_url="https://www.instagram.com/taupoluxurynails/"